/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIPromptStatusFromJSON, ApiAIPromptStatusToJSON, } from './ApiAIPromptStatus';
export function ApiSimpleComponentAIPromptFromJSON(json) {
    return ApiSimpleComponentAIPromptFromJSONTyped(json, false);
}
export function ApiSimpleComponentAIPromptFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'status': !exists(json, 'status') ? undefined : ApiAIPromptStatusFromJSON(json['status']),
    };
}
export function ApiSimpleComponentAIPromptToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'status': ApiAIPromptStatusToJSON(value.status),
    };
}
